import API from './API.js'
import axios from 'axios'

export default class ToDo extends API {
  constructor() {
    super('to_dos')
  }
  // //to_dos/{to_do}/toggle_status
  async ToggleStatus(id) {
    try {
      const response = await axios.post(`/to_dos/${id}/toggle_status`)
      return response.data
    } catch (error) {
      if (error.response) {
        // Request made and server responded
        return error.response.data;

      }
    }


  }
}
